"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnotationListSchema = exports.AnnotationSchema = void 0;
// packages/shared/src/textsign-annotation.ts
const zod_1 = require("zod");
exports.AnnotationSchema = zod_1.z.object({
    id: zod_1.z.number().int().optional(),
    signLevel: zod_1.z.number().int().min(1).max(20),
    pageIndex: zod_1.z.number().int().min(1).max(1000),
    x: zod_1.z.number().finite().min(0).max(10000),
    y: zod_1.z.number().finite().min(0).max(10000),
    w: zod_1.z.number().finite().min(1).max(5000),
    h: zod_1.z.number().finite().min(1).max(5000),
});
exports.AnnotationListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.AnnotationSchema),
});
